import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import { dateOptionsCriteria, footfallTabCriteria, boundariesCriteria } from '../../../utilities/epic-helpers';

import {
  FETCH_INSIGHTS_SUMMARY,
  FETCH_INSIGHTS_SUMMARY_ERROR,
  SET_INSIGHTS_SUMMARY,
} from '../../constants';

const insightsSummary = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_INSIGHTS_SUMMARY),
    switchMap(() =>
      ajax({
        url: `${
          state$.value.auth.server
        }/report/summary?${
          footfallTabCriteria(state$)
        }${
          boundariesCriteria(state$)
        }${
          dateOptionsCriteria(state$, 'footfall')
        }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
      }).pipe(
        map(response => {
          return {
            type: SET_INSIGHTS_SUMMARY,
            data: response.response,
          };
        }),
        catchError(error =>
          of({
            type: FETCH_INSIGHTS_SUMMARY_ERROR,
            error,
          })
        )
      )
    )
  );

export default insightsSummary;
